/**
 * Finance Route Loaders
 */

import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { financeApi } from '../api/finance-api'
import { financeActions } from '../../store/finance.slice'

interface RouterContext {
  store: {
    dispatch: Dispatch<UnknownAction>
    getState: () => unknown
  }
}

export const financeLoader = async ({ context }: { context: RouterContext }) => {
  const { store:{dispatch} } = context
  try {
    dispatch(financeActions.setLoading(true))
    const [transactionsResponse, stats] = await Promise.all([
      financeApi.getTransactions(),
      financeApi.getFinanceStats(),
    ])
    dispatch(financeActions.fetchTransactionsSuccess(transactionsResponse))
    dispatch(financeActions.setStats(stats))
    return null
  } catch (error) { dispatch(financeActions.setError((error as Error).message)); return null }
}

export const paymentsLoader = async ({ context }: { context: RouterContext }) => {
  const { store:{dispatch} } = context
  try {
    dispatch(financeActions.setLoading(true))
    const payments = await financeApi.getPayments()
    dispatch(financeActions.setPayments(payments))
    return null
  } catch (error) { dispatch(financeActions.setError((error as Error).message)); return null }
}

export const statementLoader = async ({ context }: { context: RouterContext }) => {
  const { store:{dispatch} } = context
  const now = new Date()
  const periodStart = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0]
  const periodEnd = now.toISOString().split('T')[0]
  try {
    dispatch(financeActions.setLoading(true))
    const statement = await financeApi.getStatement(periodStart, periodEnd)
    dispatch(financeActions.setStatement(statement))
    return null
  } catch (error) { dispatch(financeActions.setError((error as Error).message)); return null }
}
